import { createContext, useCallback, useContext, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fallbackContent = {
  hero_kicker: "Your skilled career starts here",
  hero_heading: "Your first industry role",
  hero_highlight: "starts with a skill.",
  hero_description: "Find trusted NAPS, NATS and entry-level opportunities made for ITI, Diploma and 12th-pass candidates.",
  hero_background_url: "https://images.pexels.com/photos/32845696/pexels-photo-32845696.jpeg",
  find_jobs_label: "Find opportunities / अवसर खोजें",
  hiring_label: "I’m hiring talent",
  trust_badge_one: "No login needed",
  trust_badge_two: "ITI · Diploma · 12th",
  search_placeholder: "Search trade, company or city",
  opportunities_eyebrow: "Live opportunities / लाइव अवसर",
  opportunities_heading: "Apprenticeships that move you forward.",
  job_view_label: "View opportunity / अवसर देखें",
  pathways_eyebrow: "Explore by pathway",
  pathways_heading: "Skills that industry needs.",
  categories: [
    { label: "Manufacturing", hindi_label: "मैन्युफैक्चरिंग", image_url: "https://images.pexels.com/photos/31091544/pexels-photo-31091544.jpeg" },
    { label: "Electrical", hindi_label: "इलेक्ट्रिकल", image_url: "https://images.pexels.com/photos/29988955/pexels-photo-29988955.jpeg" },
    { label: "Mechanical", hindi_label: "मैकेनिकल", image_url: "https://images.unsplash.com/photo-1740914994068-cf0325e0ed36" },
  ],
  partner_eyebrow: "For industry partners",
  partner_heading: "Build your workforce with skilled, ready learners.",
  partner_description: "Share your requirement and connect with apprenticeship-ready candidates.",
  partner_button_label: "Post your requirement",
  blog_eyebrow: "Insights / अपडेट्स",
  blog_heading: "News and guidance for your next step.",
  blog_button_label: "View all posts",
  blog_read_label: "Read article",
  header_jobs_label: "Find Jobs / नौकरी खोजें",
  header_blog_label: "Blog",
  header_gallery_label: "Gallery",
  header_call_label: "Call Now",
  header_apply_label: "Apply Now",
  header_post_label: "Post a Job / जॉब पोस्ट करें",
  footer_tagline: "A better beginning for skilled careers.",
  footer_address_heading: "Company Address",
  footer_contact_heading: "Contact Details",
  footer_website_heading: "Website URL",
};

const SiteContentContext = createContext({ content: fallbackContent, refreshContent: async () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(fallbackContent);

  const refreshContent = useCallback(async () => {
    const response = await fetch(`${API}/content/homepage`);
    if (!response.ok) throw new Error("Could not load homepage content");
    const data = await response.json();
    setContent(data);
  }, []);

  useEffect(() => {
    refreshContent().catch(() => setContent(fallbackContent));
  }, [refreshContent]);
  return <SiteContentContext.Provider value={{ content, refreshContent }}>{children}</SiteContentContext.Provider>;
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}